import { render, staticRenderFns } from "./crmTagsCreate.vue?vue&type=template&id=362637c1&scoped=true"
import script from "./crmTagsCreate.vue?vue&type=script&lang=js"
export * from "./crmTagsCreate.vue?vue&type=script&lang=js"
import style0 from "./crmTagsCreate.vue?vue&type=style&index=0&id=362637c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362637c1",
  null
  
)

export default component.exports